export default "__VITE_ASSET__afa8e857__"